/**
 * All API urls and other constants will reside here.
 * It is always a good idea to keep a local copy of all API response to
 * keep your app working for UI changes and
 * make it independent of network requirements.
 *
 * They need to be categorised and grouped together as:
 *  - Actual endpoints url.
 *  - Local data .json file path.
 * At a moment only one group should be uncommented.
 *
 * Other way to deal with this is to name every json file as per your service endpoint and use a basepath variable.
 * Toggle this basePath variable between "actual-domain.com/" or "/data/".
 */
export const API_SERVER =
  process.env.REACT_APP_API_SERVER || "http://localhost:8080";

export const TEST_ACCOUNTS = [
  "narens-shop.myshopify.com",
  "joys-shop-2.myshopify.com",
  "apptest-17.myshopify.com",
  "orientalartisans.myshopify.com",
  "goa-fish-market-test.myshopify.com",
  "storebuilder-test.myshopify.com",
];

export const AMPLITUDE_API_KEY = process.env.REACT_APP_AMPLITUDE_API_KEY;

export const SHOPIFY_API_KEY = process.env.REACT_APP_SHOPIFY_API_KEY;

/**
 * Builds the "reopen this app in Shopify Admin" URL for a given shop domain.
 * Returns null when the shop domain isn't known (caller should fall back to
 * generic instructions instead of a broken link).
 *
 * Example:
 *   getShopifyAdminAppUrl("my-shop.myshopify.com")
 *   => "https://my-shop.myshopify.com/admin/apps/e744a9955269cd791cf2b207a45f7978"
 */
export const getShopifyAdminAppUrl = (shopName) =>
  shopName && SHOPIFY_API_KEY
    ? `https://${shopName}/admin/apps/${SHOPIFY_API_KEY}`
    : null;

export const SHOPIFY_OAUTH_APP_URL = "https://shopify.com/admin/apps/ifh-app-listing-test";


// Actual endpoints. Uncomment below section to use actual data.
export const AUTH_USER = () => `${API_SERVER}/api/login`;
export const ACCOUNT_DETAILS = () => `${API_SERVER}/api/account/details`;
export const ACCOUNT_DETAILS_UPDATE = () => `${API_SERVER}/api/account/update`;
export const CHATBOT_BETA_ENROLL = () => `${API_SERVER}/api/account/chatbot/enroll`;
export const UPDATE_SHOP_ONBOARDING_STATUS = () =>
  `${API_SERVER}/api/onboarding/updateShopOnboardingStatus`;

export const GET_USER_STATUS = () => `${API_SERVER}/api/account/status`;
export const GET_ALL_BILLING_PLAN = () => `${API_SERVER}/api/billingplan`;
export const GET_CURRENT_BILLING_PLAN_STATUS = () =>
  `${API_SERVER}/api/billingplan/status`;
export const SET_BILLING_PLAN = () => `${API_SERVER}/api/billingplan/update`;
export const CANCEL_BILLING_PLAN = () => `${API_SERVER}/api/billingplan/cancel`;
export const GET_STORE_PRODUCTS_VARIANT_COUNT = () =>
  `${API_SERVER}/api/account/allproductvariantcount`;
export const GET_SHOP_VARIANT_LIMIT = () =>
  `${API_SERVER}/api/account/shop-variant-limit`;
export const GET_ONBOARDING_USER_STEPS_PROGRESS = () =>
  `${API_SERVER}/api/onboarding/status`;
export const GET_STORE_DETAILS = () =>
  `${API_SERVER}/api/forecast/storedetails`;

//Jobs Triggers
export const TRIGGER_ONBOARDING_INVENTORY_ORDER_JOB = () =>
  `${API_SERVER}/api/onboarding/start`;
export const GET_ONBOARDING_INVENTORY_ORDER_JOB_STATUS = () =>
  `${API_SERVER}/api/onboarding`;
export const GET_LAST_SYNC_STATUS = () =>
  `${API_SERVER}/api/bulkOperation/last_sync_details`;
export const TRIGGER_MANUAL_ORDER_INVENTORY_SYNC_JOB = () =>
  `${API_SERVER}/api/bulkOperation/manualSync`;
export const GET_ONGOING_SYNC_JOB_STATUS = () =>
  `${API_SERVER}/api/bulkOperation/pending`;

//Forecast API calls
export const GET_FORECAST_REPORT = () => `${API_SERVER}/api/forecast/list`;
export const GET_FORECAST_PAGINATED_REPORT = () => `${API_SERVER}/api/forecast/paginated-list`;
export const REGENERATE_FORECAST_REPORT = () => `${API_SERVER}/api/forecast/regenerateVersion2`;
export const GET_ALL_LIST = () => `${API_SERVER}/api/forecast/all-list`;
export const GET_FORECAST_LOCATIONS = () => `${API_SERVER}/api/forecast/locations`;
export const SAVE_FORECAST_LOCATION = () => `${API_SERVER}/api/forecast/save-location`;
export const GET_LOCATION_SWITCH_STATUS = () =>
  `${API_SERVER}/api/forecast/location-switch-status`;
export const GET_FORECAST_DASHBOARD = () => `${API_SERVER}/api/forecast/dashboard`;
export const UPDATE_FORECAST_DASHBOARD_STATUS = () =>
  `${API_SERVER}/api/forecast/dashboard/status`;



//bulk edit days of stock and lead time
export const SET_DAYS_OF_STOCK = () => `${API_SERVER}/api/forecast/daysofstock`;
export const SET_LEAD_TIME = () => `${API_SERVER}/api/forecast/leadtime`;
export const FORECAST_SETTINGS = () => `${API_SERVER}/api/forecast/settings`;
export const FORECAST_METAFIELD_DEFINITIONS = () =>
  `${API_SERVER}/api/forecast/metafield-definitions`;
export const VARIENT_SETTINGS = () =>
  `${API_SERVER}/api/forecast/settings/variant`;
export const GET_BASELINE_VELOCITY = () =>
  `${API_SERVER}/api/forecast/variant/baseline-velocity`;

/** Batch baseline velocity for multi-product chatbot (max 100 variantIds per request). */
export const POST_BASELINE_VELOCITY_BATCH = () =>
  `${API_SERVER}/api/forecast/variants/baseline-velocity`;

//incoming inventory
export const SEARCH_PRODUCT_VARIENT = () =>
  `${API_SERVER}/api/forecast/getproductsforsearch`;
export const GET_INCOMING_INVENTORIES = () =>
  `${API_SERVER}/api/forecast/incominginventory`;

export const SAVE_INCOMING_INVENTORIES = () =>
  `${API_SERVER}/api/forecast/incominginventory`;

export const REMOVE_INCOMING_INVENTORIES = () =>
  `${API_SERVER}/api/forecast/incominginventory/setting`;

export const UPDATE_INCOMING_INVENTORY = () =>
  `${API_SERVER}/api/forecast/updateincominginventory`;

export const POST_PURCHASE_ORDER_LOG = () =>
  `${API_SERVER}/api/purchaseOrder/log`;

export const GET_SHOPIFY_PERMISSION_PAGE_URL = () =>
  `${API_SERVER}/api/authorizeHistoricalOrders`;

export const GET_SHOPIFY_INVENTORY_TRANSFERS_PERMISSION_URL = () =>
  `${API_SERVER}/api/authorizeInventoryTransfers`;

export const GET_SHOPIFY_AUTHORIZE_LOCATIONS_URL = () =>
  `${API_SERVER}/api/authorizeLocations`;

//Exclude by Tag

export const GET_EXCLUDED_TAGS = () => `${API_SERVER}/api/ifhTagExcluded/index`;

export const UPDATE_EXCLUDED_TAGS = () =>
  `${API_SERVER}/api/ifhTagExcluded/updateExclusionTags`;

//Exclude Orders by Tag

export const GET_EXCLUDED_ORDER_TAGS = () =>
  `${API_SERVER}/api/orderTagExcluded/index`;

export const UPDATE_EXCLUDED_ORDER_TAGS = () =>
  `${API_SERVER}/api/orderTagExcluded/updateExclusionTags`;
